import Vue from 'vue'
import Router from 'vue-router'
// import hooks from './hooks'


const Home = () => import('@/views/Home.vue')
const Policy = () => import('@/views/privacyPolicy.vue')
const Protocol = () => import('@/views/userProtocol.vue')
const DetailedConfiguration = () => import('@/views/DetailedConfiguration.vue')
const ecfDetails = () => import('@/views/ecfDetails.vue')
const DetailsThird = () => import('@/views/detailsThird.vue')
const DetailsSecond = () => import('@/views/detailsSecond.vue')
const DetailsFirst = () => import('@/views/detailsFirst.vue')
const ArcfoxDetails = () => import('@/views/arcfoxDetails.vue')
const LowerShelf = () => import('@/views/LowerShelf.vue')
const download = () => import('@/views/download.vue')
// const register = () => import('@/views/register.vue')
const activeReg = () => import('@/views/activeReg.vue')
const activeReg1 = () => import('@/views/activeReg1.vue')
const regSucceed = () => import('@/views/regSucceed.vue')
const hotEnd = () => import('@/views/hotEnd.vue')
const LuckyDraw = () => import('@/views/LuckyDraw.vue')
const WinningInformation = () => import('@/views/WinningInformation.vue')
const turntable = () => import('@/views/turntable.vue')
const message = () => import('@/views/message.vue')
const reservationAddInformation = () => import('@/views/reservationAddInformation.vue')
const letter = () => import('@/views/letter.vue')
const depositAgreement = () => import('@/views/depositAgreement.vue')
const intentAgreement = () => import('@/views/intentAgreement.vue')
const intentAgreementAlphaS = () => import('@/views/intentAgreementAlphaS.vue')

const settingDetail = () => import('@/views/settingDetail')
const QA = () => import('@/views/QA')
const subscriptionBenefits = () => import('@/views/subscriptionBenefits')
const financialPolicy = () => import('@/views/financialPolicy')
const appointmentForMaintenance = () => import('@/views/appointmentForMaintenance')
const chargingPile = () => import('@/views/chargingPile')
const longTengCourtesy = () => import('@/views/longTengCourtesy')
const pickUpAndDeliveryCar = () => import('@/views/pickUpAndDeliveryCar')
const roadRescue = () => import('@/views/roadRescue')
const serviceMap = () => import('@/views/serviceMap')
const servicePackage = () => import('@/views/servicePackage')
const valetService = () => import('@/views/valetService')
const Page20201021img = () => import('@/views/20201021img')
const Page20201026 = () => import('@/views/20201026')
const travel = () => import('@/views/travel')
const vote = () => import('@/views/vote')
const travelWithoutWorry = () => import('@/views/travelWithoutWorry')
const bigServiceRights = () => import('@/views/bigServiceRights')
const serviceDetail = () => import('@/views/serviceDetail')
const downJXD1 = () => import('@/views/downJXD1')
const downSHCZ = () => import('@/views/downSHCZ')
const depositAgreementAlphaS = () => import('@/views/depositAgreementAlphaS')
const depositAgreementAlphaHbt = () => import('@/views/depositAgreementAlphaHbt')
const maintenanceAgreement = () => import('@/views/maintenanceAgreement')
const pickCarAgreement = () => import('@/views/pickCarAgreement')
const pickCarIntroduce = () => import('@/views/pickCarIntroduce')
const appointDrive = () => import('@/views/appointDrive')
const userRights = () => import('@/views/userRights')
const urbanService = () => import('@/views/urbanService')
const calculator = () => import('@/views/calculator')
const cancellationExplain = () => import('@/views/cancellationExplain')
const cancellationExplainAgreement = () => import('@/views/cancellationExplainAgreement')
const chargingAgreement = () => import('@/views/chargingAgreement')
const topicPage = () => import('@/views/topicPage')
const powerAttorney = () => import('@/views/powerAttorney')
const networkAccess = () => import('@/views/networkAccess')
const authentication = () => import('@/views/authentication')
const integralExplain = () => import('@/views/integralExplain')
const inviteRule = () => import('@/views/inviteRule')
const vehicleDetail = () => import('@/views/vehicleDetail')
const sdk = () => import('@/views/sdk')
const member = () => import('@/views/member')
const driveReport = () => import('@/views/driveReport')
const vehicleGuess = () =>  import('@/views/vehicleGuess')
const ruleBook = () =>  import('@/views/ruleBook')
const vehicleManual = () => import('@/views/vehicleManual')
const advanceRule = () => import('@/views/advanceRule')
const unifyAgreement = () => import('@/views/unifyAgreement')
const unifyDeposit = () => import('@/views/unifyDeposit')
const insurePolicy = () => import('@/views/insurePolicy')
const attorney = () => import('@/views/attorney')
const kaolaDetail = () => import('@/views/kaolaDetail')
const vehiclePresale = () => import('@/views/vehiclePresale')
const unservice = () => import('@/views/unservice')
const vehiclePurchase = () => import('@/views/vehiclePurchase')
const optionalDetail = () => import('@/views/optionalDetail')
const presaleRule = () => import('@/views/presaleRule')
const inviteRuleXcx = () => import('@/views/inviteRuleXcx')
const kaolaHX = () => import('@/views/kaolaHX')
const enterpriseAuth = () => import('@/views/enterpriseAuth')


Vue.use(Router)
const routerInstance = new Router({
  mode: 'history',
  base: '/arcfoxDigital',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: 'Home'
      }
    },
    
    {
      path: '/downJXD1',
      name: 'downJXD1',
      component: downJXD1,
      meta: {
        title: '下载'
      }
    },
    {
      path: '/downSHCZ',
      name: 'downSHCZ',
      component: downSHCZ,
      meta: {
        title: '下载'
      }
    },
    {
      path: '/Ch',
      name: 'Ch',
      component: downSHCZ,
      meta: {
        title: '下载'
      }
    },
    {
      path: '/serviceDetail',
      name: 'serviceDetail',
      component: serviceDetail,
      meta: {
        title: '服务详情'
      }
    },
    {
      path: '/travelWithoutWorry',
      name: 'travelWithoutWorry',
      component: travelWithoutWorry,
      meta: {
        title: 'ARCFOX畅行无忧服务套餐协议'
      }
    },
    {
      path: '/bigServiceRights',
      name: 'bigServiceRights',
      component: bigServiceRights,
      meta: {
        title: '品牌车主服务权益告知书'
      }
    },
    
    {
      path: '/vote',
      name: 'vote',
      component: vote,
      meta: {
        title: '活动详情'
      }
    },
    {
      path: '/travel',
      name: 'travel',
      component: travel,
      meta: {
        title: '极狐之旅'
      }
    },
    {
      path: '/20201021img',
      name: '20201021img',
      component: Page20201021img,
      meta: {
        title: '活动详情'
      }
    },
    {
      path: '/20201026',
      name: '20201026',
      component: Page20201026,
      meta: {
        title: '活动详情'
      }
    },
    {
      path: '/valetService',
      name: 'valetService',
      component: valetService,
      meta: {
        title: '代驾服务'
      }
    },
    {
      path: '/servicePackage',
      name: 'servicePackage',
      component: servicePackage,
      meta: {
        title: '服务套餐'
      }
    },
    {
      path: '/serviceMap',
      name: 'serviceMap',
      component: serviceMap,
      meta: {
        title: '服务地图'
      }
    },
    {
      path: '/roadRescue',
      name: 'roadRescue',
      component: roadRescue,
      meta: {
        title: '道路救援'
      }
    },
    {
      path: '/pickUpAndDeliveryCar',
      name: 'pickUpAndDeliveryCar',
      component: pickUpAndDeliveryCar,
      meta: {
        title: '取送车服务'
      }
    },
    {
      path: '/longTengCourtesy',
      name: 'longTengCourtesy',
      component: longTengCourtesy,
      meta: {
        title: '龙腾礼遇'
      }
    },
    {
      path: '/chargingPile',
      name: 'chargingPile',
      component: chargingPile,
      meta: {
        title: '专属充电桩'
      }
    },
    {
      path: '/appointmentForMaintenance',
      name: 'appointmentForMaintenance',
      component: appointmentForMaintenance,
      meta: {
        title: '预约维护'
      }
    },
    {
      path: '/arcfoxDigital/subscriptionBenefits',
      name: 'arcfoxDigitalSubscriptionBenefits',
      component: subscriptionBenefits,
      meta: {
        title: '车主权益'
      }
    },
    {
      path: '/subscriptionBenefits',
      name: 'subscriptionBenefits',
      component: subscriptionBenefits,
      meta: {
        title: '车主权益'
      }
    },
    {
      path: '/financialPolicy',
      name: 'financialPolicy',
      component: financialPolicy,
      meta: {
        title: '金融政策'
      }
    },
    {
      path: '/QA',
      name: 'QA',
      component: QA,
      meta: {
        title: '问答'
      }
    },
    {
      path: '/settingDetail',
      name: 'settingDetail',
      component: settingDetail,
      meta: {
        title: '配置详情'
      }
    },
    {
      path: '/depositAgreementAlphaS',
      name: 'depositAgreementAlphaS',
      component: unifyDeposit,
      meta: {
        title: 'ARCFOX车辆购买定金协议V3.0'
      }
    },
    {
      path: '/chargingAgreement',
      name: 'chargingAgreement',
      component: chargingAgreement,
      meta: {
        title: 'ARCFOX 极狐充电桩报修用户协议'
      }
    },

    {
      path: '/pickCarIntroduce',
      name: 'pickCarIntroduce',
      component: pickCarIntroduce,
      meta: {
        title: '取送车服务介绍'
      }
    },

    {
      path: '/pickCarAgreement',
      name: 'pickCarAgreement',
      component: pickCarAgreement,
      meta: {
        title: '取送车协议'
      }
    },
    {
      path: '/cancellation',
      name: 'cancellation',
      component: cancellationExplain,
      meta: {
        title: '注销说明文案'
      }
    },
    {
      path: '/cancellationAgreement',
      name: 'cancellationAgreement',
      component: cancellationExplainAgreement,
      meta: {
        title: '重要提醒'
      }
    },

    {
      path: '/maintenanceAgreement',
      name: 'maintenanceAgreement',
      component: maintenanceAgreement,
      meta: {
        title: '维保预约协议'
      }
    },
    
    {
      path: '/depositAgreement',
      name: 'depositAgreement',
      component: unifyDeposit,
      meta: {
        title: '定金协议'
      }
    },
    {
      path: '/intentAgreement',
      name: 'intentAgreement',
      component: unifyAgreement,
      meta: {
        title: '购买意向协议'
      }
    },
    {
      path: '/depositAgreementHbt',
      name: 'depositAgreementHbt',
      component: unifyAgreement,
      meta: {
        title: '购买意向协议'
      }
    },
    {
      path: '/intentAgreementAlphaS',
      name: 'intentAgreementAlphaS',
      component: unifyAgreement,
      meta: {
        title: '购买意向协议'
      }
    },
    {
      path: '/intentAgreementAlphaHbt',
      name: 'intentAgreementAlphaHbt',
      component: unifyDeposit,
      meta: {
        title: 'ARCFOX车辆购买定金协议V3.0'
      }
    },
    {
      path: '/message',
      name: 'message',
      component: message,
      meta: {
        title: '消息详情'
      }
    },
    {
      path: '/register',
      name: 'register',
      component: hotEnd,
      meta: {
        title: '欢迎来到ARCFOX'
      }
    },
    {
      path: '/regSucceed',
      name: 'regSucceed',
      component: regSucceed,
      meta: {
        title: '欢迎来到ARCFOX'
      }
    },
    {
      path: '/download',
      name: 'download',
      component: download,
      meta: {
        title: '下载'
      }
    },
    {
      path: '/downPage',
      name: 'downPage',
      component: download,
      meta: {
        title: '下载页'
      }
    },
    {
      path: '/downspace1',
      name: 'downspace1',
      component: download,
      meta: {
        title: '下载页'
      }
    },
    {
      path: '/downBD',
      name: 'downBD',
      component: download,
      meta: {
        title: '下载'
      }
    },
    {
      path: '/downBD1',
      name: 'downBD1',
      component: download,
      meta: {
        title: '下载'
      }
    },
    {
      path: '/downBD2',
      name: 'downBD2',
      component: download,
      meta: {
        title: '下载'
      }
    },
    {
      path: '/downBD3',
      name: 'downBD3',
      component: download,
      meta: {
        title: '下载'
      }
    },
    {
      path: '/downBD4',
      name: 'downBD4',
      component: download,
      meta: {
        title: '下载'
      }
    },
    {
      path: '/downBD5',
      name: 'downBD5',
      component: download,
      meta: {
        title: '下载'
      }
    },
    {
      path: '/downsltwz0514',
      name: 'downsltwz0514',
      component: download,
      meta: {
        title: '下载'
      }
    },
    {
      path: '/downWB',
      name: 'downWB',
      component: download,
      meta: {
        title: '下载'
      }
    },
    {
      path: '/downGW',
      name: 'downGW',
      component: download,
      meta: {
        title: '下载'
      }
    },
    {
      path: '/downSQ1',
      name: 'downSQ1',
      component: download,
      meta: {
        title: '下载'
      }
    },
    {
      path: '/policy',
      name: 'policy',
      component: Policy,
      meta: {
        title: '隐私政策'
      }
    },
    {
      path: '/sdk',
      name: 'sdk',
      component: sdk,
      meta: {
        title: '第三方SDK目录'
      }
    },
    {
      path: '/protocol',
      name: 'protocol',
      component: Protocol,
      meta: {
        title: '用户协议'
      }
    },
    {
      path: '/HotDetails',
      name: 'HotDetails',
      component: unservice,
      meta: {
        title: '活动详情'
      }
    },
    {
      path: '/HotDetails&:parms',
      name: 'HotDetailsNew',
      component: unservice,
      meta: {
        title: '活动详情'
      }
    },
    {
      path: '/hotEnd',
      name: 'hotEnd',
      component: hotEnd,
      meta: {
        title: '活动详情'
      }
    },
    {
      path: '/deepDrive',
      name: 'deepDrive',
      component: unservice,
      meta: {
        title: '极狐深度试驾活动'
      }
    },
    {
      path: '/appointDrive',
      name: 'appointDrive',
      component: appointDrive,
      meta: {
        title: '预约试驾',
        keepAlive: true
      }
    },
    {
      path: '/InfoDetail&:parms',
      name: 'infoDetailNew',
      component: unservice,
      meta: {
        title: '资讯详情'
      }
    },
    {
      path: '/InfoDetail',
      name: 'infoDetail',
      component: unservice,
      meta: {
        title: '资讯详情'
      }
    },
    {
      path: '/ArcfoxDetails',
      name: 'ArcfoxDetails',
      component: ArcfoxDetails,
      meta: {
        title: '车型详情'
      }
    },
    {
      path: '/DetailsFirst',
      name: 'DetailsFirst',
      component: DetailsFirst,
      meta: {
        title: '无界美学'
      }
    },
    {
      path: '/DetailsSecond',
      name: 'DetailsSecond',
      component: DetailsSecond,
      meta: {
        title: '人本科技'
      }
    },
    {
      path: '/DetailsThird',
      name: 'DetailsThird',
      component: DetailsThird,
      meta: {
        title: '极致体验'
      }
    },
    {
      path: '/DetailedConfiguration',
      name: 'DetailedConfiguration',
      component: DetailedConfiguration,
      meta: {
        title: '详细配置'
      }
    },
    {
      path: '/ecfDetails',
      name: 'ecfDetails',
      component: ecfDetails,
      meta: {
        title: 'ECT车型'
      }
    },
    {
      path: '/LowerShelf',
      name: 'LowerShelf',
      component: LowerShelf,
      meta: {
        title: '产品下架'
      }
    },
    {
      path: '/downZSYH',
      name: 'activeReg',
      component: activeReg,
      meta: {
        title: 'ARCFOX惊喜之旅'
      }
    },
    {
      path: '/downXMLY',
      name: 'downXMLY',
      component: activeReg,
      meta: {
        title: 'ARCFOX惊喜之旅'
      }
    },
    {
      path: '/downJKBD',
      name: 'downJKBD',
      component: activeReg,
      meta: {
        title: 'ARCFOX惊喜之旅'
      }
    },
    {
      path: '/downINSTA',
      name: 'downINSTA',
      component: activeReg,
      meta: {
        title: 'ARCFOX惊喜之旅'
      }
    },
    {
      path: '/downHW1',
      name: 'downHW1',
      component: activeReg,
      meta: {
        title: 'ARCFOX惊喜之旅'
      }
    },
    {
      path: '/downHXXD',
      name: 'downHXXD',
      component: activeReg1,
      meta: {
        title: 'ARCFOX惊喜之旅'
      }
    },
    {
      path: '/downGZCZ1',
      name: 'downGZCZ1',
      component: activeReg1,
      meta: {
        title: 'ARCFOX惊喜之旅'
      }
    },
    {
      path: '/LuckyDraw',
      name: 'LuckyDraw',
      component: LuckyDraw,
      meta: {
        title: '抽奖活动'
      }
    },
    {
      path: '/WinningInformation',
      name: 'WinningInformation',
      component: WinningInformation,
      meta: {
        title: '抽奖活动'
      }
    },
    {
      path: '/turntable',
      name: 'turntable',
      component: turntable,
      meta: {
        title: '转盘抽奖'
      }
    },
    {
      path: '/reservationAddInformation',
      name: 'reservationAddInformation',
      component: reservationAddInformation,
      meta: {
        title: '预约信息'
      }
    },
    {
      path: '/letter',
      name: 'letter',
      component: letter,
      meta: {
        title: 'ARCFOX生而破界'
      }
    },
    {
      path: '/userRights',
      name: 'userRights',
      component: userRights,
      meta: {
        title: '我的权益'
      }
    },
    {
      path: '/urbanService',
      name: 'urbanService',
      component: urbanService,
      meta: {
        title: '城市服务能力'
      }
    },
    {
      path: '/calculator',
      name: 'calculator',
      component: calculator,
      meta: {
        title: '金融计算方案'
      }
    },
    {
      path: '/topicPage',
      name: 'topicPage',
      component: topicPage,
      meta: {
        title: '专题详情页'
      }
    },
    {
      path: '/powerAttorney',
      name: 'powerAttorney',
      component: powerAttorney,
      meta: {
        title: '委托书'
      }
    },
    {
      path: '/networkAccess',
      name: 'networkAccess',
      component: networkAccess,
      meta: {
        title: '入网协议'
      }
    },
    {
      path: '/authentication',
      name: 'authentication',
      component: authentication,
      meta: {
        title: '企业实名认证'
      }
    },
    {
      path: '/integralExplain',
      name: 'integralExplain',
      component: integralExplain,
      meta: {
        title: '积分说明'
      }
    },
    {
      path: '/vehicleDetail',
      name: 'vehicleDetail',
      component: vehicleDetail,
      meta: {
        title: '车辆详情'
      }
    },
    {
      path: '/inviteRule',
      name: 'inviteRule',
      component: inviteRule,
      meta: {
        title: '邀请规则'
      }
    },
    {
      path: '/inviteRuleXcx',
      name: 'inviteRuleXcx',
      component: inviteRuleXcx,
      meta: {
        title: '邀请规则'
      }
    },
    {
      path: '/member',
      name: 'member',
      component: member,
      meta: {
        title: '会员中心'
      }
    },
    {
      path: '/driveReport',
      name: 'driveReport',
      component: driveReport,
      meta: {
        title: 'ARCFOX极狐 试驾报告'
      }
    },
    {
      path: '/vehicleGuess',
      name: 'vehicleGuess',
      component: vehicleGuess,
      meta: {
        title: '预售开启'
      }
    },
    {
      path: '/ruleBook',
      name: 'ruleBook',
      component: ruleBook,
      meta: {
        title: '预售说明'
      }
    },
    {
      path: '/vehicleManual',
      name: 'vehicleManual',
      component: vehicleManual,
      meta: {
        title: '车辆手册'
      }
    },
    {
      path: '/advanceRule',
      name: 'advanceRule',
      component: advanceRule,
      meta: {
        title: '定金协议'
      }
    },
    {
      path: '/presaleRule',
      name: 'presaleRule',
      component: presaleRule,
      meta: {
        title: '定金协议'
      }
    },
    {
      path: '/insurePolicy',
      name: 'insurePolicy',
      component: insurePolicy,
      meta: {
        title: '隐私政策'
      }
    },
    {
      path: '/attorney',
      name: 'attorney',
      component: attorney,
      meta: {
        title: '授权书'
      }
    },
    {
      path: '/kaolaDetail',
      name: 'kaolaDetail',
      component: kaolaDetail,
      meta: {
        title: '车辆详情'
      }
    },
    {
      path: '/vehiclePresale',
      name: 'vehiclePresale',
      component: vehiclePresale,
      meta: {
        title: '预售开启',
        keepAlive: true
      }
    },
    {
      path: '/vehiclePurchase',
      name: 'vehiclePurchase',
      component: vehiclePurchase,
      meta: {
        title: '购车信息'
      }
    },
    {
      path: '/unservice',
      name: 'unservice',
      component: unservice,
      meta: {
        title: '无服务'
      }
    },
    {
      path: '/optionalDetail',
      name: 'optionalDetail',
      component: optionalDetail,
      meta: {
        title: '选装详情'
      }
    },
    {
      path: '/kaolaHX',
      name: 'kaolaHX',
      component: kaolaHX,
      meta: {
        title: '预约试驾'
      }
    },
    {
      path: '/enterpriseAuth',
      name: 'enterpriseAuth',
      component: enterpriseAuth,
      meta: {
        title: '企业实名认证授权书'
      }
    },
  ]
})

routerInstance.beforeEach(async (to, from, next) => {
  if (to.meta && to.meta.title) { // 判断是否有标题
    document.title = to.meta.title;
  }
  next()
});
// const beforeEachKeys = Object.keys(hooks.beforeEach)

// if (beforeEachKeys.length > 0) {
//   beforeEachKeys.map(hook => {
//     routerInstance.beforeEach(hooks.beforeEach[hook])
//   }) 
// }

export default routerInstance
